"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _responsive = require("../responsive");

var _screenReaderOnly = require("../screen-reader-only");

var _utils = require("../utils");

var _ToggleButtonGroupBase = require("./ToggleButtonGroupBase");

var _interfaces = require("./interfaces");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["children", "className", "disabled", "getHiddenText", "isMulti", "onChange", "value", "layout"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var defaultProps = {
  isMulti: false,
  getHiddenText: function getHiddenText(count) {
    return "".concat(count, " items in toggle group");
  },
  layout: _interfaces.ToggleButtonGroupLayout.Horizontal
};

var ToggleButtonGroupWithoutDocs = function ToggleButtonGroupWithoutDocs(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      _ref$getHiddenText = _ref.getHiddenText,
      getHiddenText = _ref$getHiddenText === void 0 ? defaultProps.getHiddenText : _ref$getHiddenText,
      isMulti = _ref.isMulti,
      onChange = _ref.onChange,
      value = _ref.value,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? defaultProps.layout : _ref$layout,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var handleMultipleChange = (0, _react.useCallback)(function (event, buttonValue) {
    var foundIndex = value ? value.indexOf(buttonValue) : -1;
    var newValue;

    if (value && foundIndex >= 0 && Array.isArray(value)) {
      newValue = value.filter(function (_, i) {
        return i !== foundIndex;
      });
    } else {
      newValue = [].concat((0, _toConsumableArray2.default)(value || []), [buttonValue]);
    }

    onChange(event, newValue);
  }, [value, onChange]);
  var handleSingleChange = (0, _react.useCallback)(function (event, buttonValue) {
    onChange(event, value === buttonValue ? undefined : buttonValue);
  }, [value, onChange]);

  var _useHighZoomLevel = (0, _responsive.useHighZoomLevel)({
    checkOnlyWidth: true
  }),
      isInHighZoomLevel = _useHighZoomLevel.isInHighZoomLevel;

  return (0, _core.jsx)(_ToggleButtonGroupBase.ToggleButtonGroupBase, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    isInReflow: isInHighZoomLevel,
    layout: layout,
    className: className,
    style: _ToggleButtonGroupBase.rootStyles,
    hasSingleChild: _react.default.Children.count(children) === 1
  }), (0, _core.jsx)("legend", null, (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, getHiddenText(_react.default.Children.count(children)))), _react.default.Children.map(children, function (child) {
    if (! /*#__PURE__*/_react.default.isValidElement(child)) {
      return null;
    }

    var item = child;
    return /*#__PURE__*/_react.default.cloneElement(item, {
      'aria-label': item.props['aria-label'],
      isSelected: item.props.isSelected === undefined ? (0, _utils2.isValueSelected)(item.props.value, value) : item.props.isSelected,
      onChange: isMulti ? handleMultipleChange : handleSingleChange,
      disabled: item.props.disabled || disabled
    });
  }));
};

ToggleButtonGroupWithoutDocs.defaultProps = _objectSpread({}, defaultProps);
var ToggleButtonGroupWithDocs = (0, _stencilReactDesc.describe)(ToggleButtonGroupWithoutDocs).description('Used to group related toggle buttons.');
ToggleButtonGroupWithDocs.propTypes = {
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the toggle button from being clicked.'),
  getHiddenText: _stencilReactDesc.PropTypes.func.description('Function to provide an accessible hidden text for the group of toggle buttons.'),
  isMulti: _stencilReactDesc.PropTypes.bool.description('Determines whether selecting several toggle buttons be selected.'),
  onChange: _stencilReactDesc.PropTypes.func.isRequired.description('Called when the toggle button value changes.').format("(\n    event: React.FormEvent<HTMLElement>,\n    value: string | string[]\n  ) => void"),
  value: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.string)]).description('Selects a predefined value for the toggle button group.'),
  layout: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ToggleButtonGroupLayout)).description('Determines how the toggle button group is arranged in small screen sizes.')
};
var ToggleButtonGroup = (0, _utils.withTestAttributes)({
  component: 'StencilReactToggleButtonGroup'
})(ToggleButtonGroupWithDocs);
ToggleButtonGroup.displayName = 'ToggleButtonGroup';
var _default = ToggleButtonGroup;
exports.default = _default;